import { ActionButton, ActionButtonType, Callout } from "@octopusdeploy/design-system-components";
import React from "react";
import { repository } from "~/clientInstance";
import ActionList from "~/components/ActionList";
import type { DoBusyTask } from "~/components/DataBaseComponent/DataBaseComponent";
import ConfirmationDialog from "~/components/Dialog/ConfirmationDialog";
import Section from "~/components/Section";
interface ConfirmTentacleUpgradePanelState {
    showUpgradeAllTentaclesConfirmation: boolean;
    showUpgrade: boolean;
}
interface ConfirmTentacleUpgradePanelProps {
    doBusyTask: DoBusyTask;
    onTentacleUpgradeComplete(): void;
}
export class ConfirmTentacleUpgradePanel extends React.Component<ConfirmTentacleUpgradePanelProps, ConfirmTentacleUpgradePanelState> {
    private titleForUpgradeTentacles = "Upgrade all Tentacles";
    private localStorageKeyForIgnoreUpgradeVersion = "ignoreUpgradeVersiona";
    constructor(props: ConfirmTentacleUpgradePanelProps) {
        super(props);
        const octopusVersion = repository.getServerInformation().version;
        this.state = {
            showUpgradeAllTentaclesConfirmation: false,
            showUpgrade: localStorage.getItem(this.localStorageKeyForIgnoreUpgradeVersion) !== octopusVersion,
        };
    }
    render() {
        return (this.state.showUpgrade && (<React.Fragment>
                    <Section key={`showUpgrade-${this.state.showUpgrade.toString()}`}>
                        <Callout type={"warning"} title="Tentacle upgrade required">
                            <p>One or more Tentacles are running old versions of the Tentacle agent and can be upgraded. Proceeding will upgrade all targets and workers.</p>
                            <ActionList actions={[
                <ActionButton type={ActionButtonType.Primary} label={this.titleForUpgradeTentacles} onClick={() => this.setState({ showUpgradeAllTentaclesConfirmation: true })}/>,
                <ActionButton type={ActionButtonType.Secondary} label="Dismiss this update" onClick={() => this.dismissTentacleUpgrade()}/>,
            ]}/>
                        </Callout>
                    </Section>
                    <ConfirmationDialog title={this.titleForUpgradeTentacles} open={this.state.showUpgradeAllTentaclesConfirmation} onClose={() => this.setState({ showUpgradeAllTentaclesConfirmation: false })} onContinueClick={() => this.performTentacleUpgrade()}>
                        <div>
                            Please note: This is a blocking task and will prevent deployments during the upgrade.
                            <br />
                            <br />
                            Are you sure?
                        </div>
                    </ConfirmationDialog>
                </React.Fragment>));
    }
    private async performTentacleUpgrade() {
        return this.props.doBusyTask(async () => {
            await repository.Machines.upgradeAllTentacles();
            this.props.onTentacleUpgradeComplete();
        });
    }
    private dismissTentacleUpgrade() {
        const octopusVersion = repository.getServerInformation().version;
        localStorage.setItem(this.localStorageKeyForIgnoreUpgradeVersion, octopusVersion);
        this.setState({ showUpgrade: false });
    }
    static displayName = "ConfirmTentacleUpgradePanel";
}
export default ConfirmTentacleUpgradePanel;
